// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__box--BL_8M {
  border: 3px solid #f9fafa;
  border-radius: 0.5rem;
  padding: 1.5rem;
  background: #fff;
  margin: 2rem 0 2rem 2rem;
  height: calc(100% - 5rem);
}
.style__editUserDialog--pE5ms {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.style__editUserDialog--pE5ms > div {
  margin-bottom: 1rem;
}
.style__header--CLoUo {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.style__headerMain--Myp3s {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.style__headerMainRow--jPMFp {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  align-items: center;
}
.style__headerActions--ptfEA {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.style__headerActions--ptfEA svg {
  fill: #7d8287;
}
.style__headerInfo--wShhE {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.style__userContentBox--A7gPM {
  display: flex;
  flex-direction: row;
  gap: 3rem;
  overflow: hidden;
}
.style__overview--H2aYe {
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  width: 100%;
}
.style__icon--XpC6t {
  color: #7d8287;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/UserPage/style.less"],"names":[],"mappings":"AAIA;EAEI,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;AAJJ;AAHA;EAWI,aAAA;EACA,sBAAA;EACA,aAAA;AALJ;AARA;EAgBM,mBAAA;AALN;AAXA;EAqBI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAPJ;AAjBA;EA4BI,aAAA;EACA,mBAAA;EACA,8BAAA;AARJ;AAtBA;EAkCI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AATJ;AA5BA;EAyCI,aAAA;EACA,mBAAA;EACA,SAAA;AAVJ;AAjCA;EA8CM,aAAA;AAVN;AApCA;EAmDI,aAAA;EACA,mBAAA;EACA,WAAA;AAZJ;AAzCA;EAyDI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAbJ;AA/CA;EAgEI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAdJ;AArDA;EAuEI,cAAA;EACA,eAAA;AAfJ","sourcesContent":["@import '@yaak/components/src/spacing';\n@import '@yaak/components/src/colors';\n@import '@yaak/components/src/shadows';\n\n:local {\n  .box {\n    border: 3px solid @color-asphalt-grey-099;\n    border-radius: @spacing-50;\n    padding: @spacing-150;\n    background: @color-white;\n    margin: @spacing-200 0 @spacing-200 @spacing-200;\n    height: calc(100% - 5rem);\n  }\n\n  .editUserDialog {\n    display: flex;\n    flex-direction: column;\n    padding: @spacing-100;\n\n    > div {\n      margin-bottom: @spacing-100;\n    }\n  }\n\n  .header {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    width: 100%;\n  }\n\n  .headerMain {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .headerMainRow {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-75;\n    align-items: center;\n  }\n\n  .headerActions {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-100;\n\n    svg {\n      fill: @color-asphalt-grey-050;\n    }\n  }\n\n  .headerInfo {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-50;\n  }\n\n  .userContentBox {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-300;\n    overflow: hidden;\n  }\n\n  .overview {\n    flex-grow: 1;\n    height: 100%;\n    overflow: hidden;\n    width: 100%;\n  }\n\n  .icon {\n    color: @color-asphalt-grey-050;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `style__box--BL_8M`,
	"editUserDialog": `style__editUserDialog--pE5ms`,
	"header": `style__header--CLoUo`,
	"headerMain": `style__headerMain--Myp3s`,
	"headerMainRow": `style__headerMainRow--jPMFp`,
	"headerActions": `style__headerActions--ptfEA`,
	"headerInfo": `style__headerInfo--wShhE`,
	"userContentBox": `style__userContentBox--A7gPM`,
	"overview": `style__overview--H2aYe`,
	"icon": `style__icon--XpC6t`
};
export default ___CSS_LOADER_EXPORT___;
